import api from './config';

export const authAPI = {
  // Login
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  },

  // Verificar código de login (2FA)
  verifyLogin: async (email, code) => {
    const response = await api.post('/auth/verify-login', { email, code });
    return response.data;
  },

  // Registro
  register: async (email, password, name, phone, cpf) => {
    const response = await api.post('/auth/register', { email, password, name, phone, cpf });
    return response.data;
  },

  // Verificar código de email (cadastro)
  verifyEmail: async (email, code) => {
    const response = await api.post('/auth/verify-email', { email, code });
    return response.data;
  },

  // Reenviar código de verificação
  resendVerificationCode: async (email, type) => {
    const response = await api.post('/auth/resend-verification-code', { email, type });
    return response.data;
  },

  // Verificar token
  me: async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Token não encontrado');
    }

    const response = await api.get('/auth/me', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Atualizar perfil
  updateProfile: async (data) => {
    const token = localStorage.getItem('token');
    const response = await api.put('/auth/profile', data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Alterar senha
  changePassword: async (currentPassword, newPassword) => {
    const token = localStorage.getItem('token');
    const response = await api.put('/auth/password', { currentPassword, newPassword }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Listar usuários (Admin)
  getUsers: async () => {
    const token = localStorage.getItem('token');
    const response = await api.get('/auth/users', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Atualizar usuário (Admin)
  updateUser: async (id, data) => {
    const token = localStorage.getItem('token');
    const response = await api.put(`/auth/users/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Desativar usuário (Admin)
  deactivateUser: async (id) => {
    const token = localStorage.getItem('token');
    const response = await api.delete(`/auth/users/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Deletar usuário permanentemente (Master)
  deleteUserPermanently: async (id) => {
    const token = localStorage.getItem('token');
    // A rota /users/:id agora faz exclusão permanente
    const response = await api.delete(`/auth/users/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Criar usuário pelo Master Admin (com CPF)
  createUserByMaster: async (userData) => {
    const token = localStorage.getItem('token');
    const response = await api.post('/auth/users/master', userData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

export default authAPI;


